export default class MainPageSecondScreenCommon {
    public static readonly selectors = {
        screen: ".js-main-page-advantages-section",
        screenContainer: ".js-main-page-advantages-section-container",
        topContent: ".js-main-page-advantages-section-top-content",
        bottomContent: ".js-main-page-advantages-section-bottom-content",
        bottomContentCards: ".js-main-page-advantages-section-bottom-content-cards-list",
        bottomContentLinks: ".js-main-page-advantages-section-bottom-content-links",
        innerCenterPoint: ".js-main-page-advantages-section-center-content",
        cards: ".js-main-page-advantages-card",
    };
}
